export const VseDeljenePravice = {
  methods: {
    GetDeljenePravice (sharedWithMe) {
      let apiUrl = 'permissions/getAllSharedPermissions?'
      if (sharedWithMe === true) {
        apiUrl = 'permissions/getAllPermissionsSharedWithMe?'
      }
      let param = []
      this.clientAgent.postWsRequest(
        this,
        apiUrl,
        param,
        null,
        'SetDodeljenePravice',
        'ErrDodeljenePravice')
    },
    SetDodeljenePravice (podatki) {
      let nalaganje = false
      return this.VseDeljenePravicePrenos(podatki, nalaganje)
    },
    ErrDodeljenePravice (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Pravice/VseDeljenePravice.js